import React from 'react';

import { Anterior, Proximo } from './icones';

/** Rodapé com o texto à esquerda e as setas de página à direita. */
export function Paginacao({
  rodape,
  pagina,
  paginas,
  onPagina,
}: {
  rodape: string;
  pagina: number;
  paginas: number;
  onPagina: (p: number) => void;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
        fontSize: 12,
        color: '#52525B',
      }}
    >
      <span>{rodape}</span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button
          type="button"
          className="pagBtn"
          aria-label="Página anterior"
          disabled={pagina <= 1}
          onClick={() => onPagina(pagina - 1)}
        >
          <Anterior tam={14} cor="#0F172A" traco={2.4} />
        </button>
        <span style={{ fontWeight: 700, color: '#0F172A' }}>
          {pagina} / {paginas}
        </span>
        <button
          type="button"
          className="pagBtn"
          aria-label="Próxima página"
          disabled={pagina >= paginas}
          onClick={() => onPagina(pagina + 1)}
        >
          <Proximo tam={14} cor="#0F172A" traco={2.4} />
        </button>
      </div>
    </div>
  );
}
